import React from 'react';

const TownCentreIcon = ({ fill = '#222222' }) => {
  return (
    <svg width="16" height="20" viewBox="0 0 16 26" fill="none">
      <path
        d="M15.2552 8.2999C15.2052 4.1999 11.8552 0.899902 7.80524 0.899902H7.75524C3.60524 0.949902 0.25524 4.2999 0.30524 8.3999C0.30524 11.7499 4.90524 18.2499 6.60524 20.5999H2.05524C1.65524 20.5999 1.30524 20.9499 1.30524 21.3499C1.30524 21.7499 1.65524 22.0999 2.05524 22.0999H13.5052C13.9052 22.0999 14.2552 21.7499 14.2552 21.3499C14.2552 20.9499 13.9052 20.5999 13.5052 20.5999H8.95524C10.6552 18.2999 15.2552 11.7499 15.2552 8.3999V8.2999ZM13.7552 8.3999C13.7552 10.9499 9.85524 16.7999 7.80524 19.6499C5.70524 16.7999 1.80524 10.9999 1.80524 8.3999C1.75524 5.0999 4.45524 2.3999 7.70524 2.3999H7.75524C11.0052 2.3999 13.7052 5.0499 13.7052 8.2999V8.3999H13.7552Z"
        fill={fill}
      />
      <path
        d="M7.75524 4.1999C5.45524 4.1999 3.60524 6.0499 3.60524 8.3499C3.60524 10.6499 5.45524 12.4999 7.75524 12.4999C10.0552 12.4999 11.9052 10.6499 11.9052 8.3499C11.9552 6.0999 10.0552 4.1999 7.75524 4.1999ZM7.75524 11.0499C6.30524 11.0499 5.10524 9.8499 5.10524 8.3999C5.10524 6.9499 6.30524 5.7499 7.75524 5.7499C9.20524 5.7499 10.4052 6.9499 10.4052 8.3999C10.4052 9.8499 9.25524 11.0499 7.75524 11.0499Z"
        fill={fill}
      />
    </svg>
  );
};

export default TownCentreIcon;
